export default __webpack_public_path__ + "063efef9070045ecc816c9f1cd08e418.wav";